// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__EMD9E","right":"styles_right__Kl6o0"};